module.exports = __webpack_public_path__ + "images/88e9d3e8a3177403479203b56637b41b.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-characters04.jpg
// module id = ./webpack/assets/img/wheels-characters04.jpg
// module chunks = 0